(function () {
  function getMainVariantSelects() {
    return (
      document.querySelector('.custom-pdp-revamp variant-selects') ||
      document.querySelector('[data-section-type="product"] variant-selects')
    );
  }

  function getMainSubmitButton() {
    return (
      document.querySelector('#pdp-atc-buttons .product-form__submit') ||
      document.querySelector('.custom-pdp-revamp .product-form__submit')
    );
  }

  function setAtcLoading(btn, loading) {
    if (!btn) return;
    btn.classList.toggle('is-loading', loading);
    btn.disabled = loading;
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function clearAllPackAtcLoading(root) {
    root.querySelectorAll('[data-pack-atc]').forEach(function (btn) {
      setAtcLoading(btn, false);
    });
  }

  function syncPickerFromMain(root, variantSelects) {
    var checked = variantSelects.querySelector('.swatchInput:checked');
    if (!checked) return;

    document.querySelectorAll('[data-pack-variant-card]').forEach(function (card) {
      var isMatch =
        card.dataset.variantValue === checked.value &&
        card.dataset.optionName === checked.name;
      card.classList.toggle('is-selected', isMatch);
    });
  }

  function triggerVariantChange(variantSelects, input) {
    if (typeof variantSelects.onVariantChange === 'function') {
      variantSelects.onVariantChange({ target: input });
      return;
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function selectMainVariant(card, variantSelects) {
    var value = card.dataset.variantValue;
    var name = card.dataset.optionName;
    if (!value || !name) return false;

    var input = variantSelects.querySelector(
      'input.swatchInput[name="' + name.replace(/"/g, '\\"') + '"][value="' + value.replace(/"/g, '\\"') + '"]'
    );

    if (!input || input.disabled) return false;

    if (!input.checked) {
      input.checked = true;
      triggerVariantChange(variantSelects, input);
    }
    return true;
  }

  function clickMainAddToCart() {
    var btn = getMainSubmitButton();
    if (btn && btn.getAttribute('aria-disabled') !== 'true' && !btn.disabled) {
      btn.click();
      return true;
    }
    return false;
  }

  function applyDefaultPackSelection(root, variantSelects) {
    var position = parseInt(root.dataset.defaultPackPosition, 10);
    if (!position || position < 1) return false;

    var cards = root.querySelectorAll('[data-pack-variant-card]');
    var card = cards[position - 1];
    if (!card) return false;

    if (!selectMainVariant(card, variantSelects)) return false;
    syncPickerFromMain(root, variantSelects);
    return true;
  }

  function initPackPicker(root) {
    var variantSelects = getMainVariantSelects();
    if (!variantSelects) return;

    if (!applyDefaultPackSelection(root, variantSelects)) {
      syncPickerFromMain(root, variantSelects);
    }

    variantSelects.addEventListener('change', function () {
      syncPickerFromMain(root, variantSelects);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        clearAllPackAtcLoading(root);
      });
      subscribe(PUB_SUB_EVENTS.cartError, function () {
        clearAllPackAtcLoading(root);
      });
    }

    root.addEventListener('click', function (event) {
      var atcBtn = event.target.closest('[data-pack-atc]');
      var card = event.target.closest('[data-pack-variant-card]');
      if (!card) return;

      if (atcBtn) {
        event.preventDefault();
        event.stopPropagation();

        if (atcBtn.classList.contains('is-loading')) return;

        setAtcLoading(atcBtn, true);
        selectMainVariant(card, variantSelects);
        syncPickerFromMain(root, variantSelects);

        window.setTimeout(function () {
          var clicked = clickMainAddToCart();
          if (!clicked) {
            setAtcLoading(atcBtn, false);
            return;
          }

          var mainBtn = getMainSubmitButton();
          var cleared = false;

          function stopLoading() {
            if (cleared) return;
            cleared = true;
            clearAllPackAtcLoading(root);
          }

          if (mainBtn) {
            var observer = new MutationObserver(function () {
              var loading =
                mainBtn.classList.contains('loading') ||
                (mainBtn.querySelector('.loading__spinner') &&
                  !mainBtn.querySelector('.loading__spinner').classList.contains('hidden'));

              if (!loading) {
                observer.disconnect();
                stopLoading();
              }
            });
            observer.observe(mainBtn, {
              attributes: true,
              attributeFilter: ['class', 'aria-disabled'],
              subtree: true,
            });
          }

          window.setTimeout(stopLoading, 8000);
        }, 100);

        return;
      }

      event.preventDefault();
      selectMainVariant(card, variantSelects);
      syncPickerFromMain(root, variantSelects);
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var card = event.target.closest('[data-pack-variant-card]');
      if (!card || event.target.closest('[data-pack-atc]')) return;
      event.preventDefault();
      selectMainVariant(card, variantSelects);
      syncPickerFromMain(root, variantSelects);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="product-pack-picker"]').forEach(initPackPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-section-type="product-pack-picker"]');
    if (root) initPackPicker(root);
  });
})();
